import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "0b702f4e-97ca-47f1-abe1-535956d1fb94",
    content: "Two.",
    options: {},
  },
  {
    id: "03ba9155-0209-44fe-8336-a6c380424546",
    content: "As many as there are reflections excluding the direct sound.",
    options: {},
  },
  {
    id: "366a90b6-edcf-436f-8ac0-e3350066aa15",
    content: "As many as there are reflections including the direct sound.",
    options: {},
  },
  {
    id: "a2884d2d-16a2-4ae0-8fb2-b7d4e65035e4",
    content: "One for the direct sound.",
    options: {},
  },
];

export const task: Task = {
  id: "f6af1cd1-b14b-4be9-8c80-cc9cc97e67c4",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["366a90b6-edcf-436f-8ac0-e3350066aa15"],
};
